'use strict';
import React from 'react';

/**
 * Loader styles are available via the loader.scss file, loader.css or all.css files.
 *
 * Usage:
 *
 * ```Javascript
 * <Loader loading />
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} loading Renders the loader spin over the component.
 */
class ComponentLoader extends React.Component {

  renderChildren () {
    return (
      <div>
        { this.props.children }
      </div>
    );
  }

  renderActiveLoader () {
    return (
      <div style={{position: 'relative'}}>
        { this.renderChildren() }
        <div className="LoaderBackground">
          <div className="LoaderForeground">
            <div className="LoaderMsg">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { loading } = this.props;
    return (
      <div>
        { loading ? this.renderActiveLoader() : this.renderChildren() }
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Loader component
 */
ComponentLoader.propTypes = {
  loading: React.PropTypes.bool
};

ComponentLoader.defaultProps = {
  loading: false
};

export default ComponentLoader;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/componentLoader.jsx